// -----------------------------------------------------------------------------
// Scripts
// -----------------------------------------------------------------------------

var SCRIPTS = SCRIPTS || {};

$(document).ready(function () {
  SCRIPTS = {
    settings: {},
    init: function () {
      this.nav.init();
      this.headershrink.init();
      this.hero.init();
      this.fullpage.init();
      this.smoothScroll.init();
      if ($('#js-map').length > 0) {
        this.setupMap.init();
      }

      $('[data-paroller]').paroller();

      this.svgPlanSetup.init();

      if ($('#masonry').length > 0) {
        this.masonrySetup.init();
      }
    },
    masonrySetup: {
      container: $('#masonry'),
      init: function () {
        var _this = this;

        _this.container.imagesLoaded(function () {
          _this.container.masonry({
            itemSelector: '.masonry-item'
          });
        });
      }
    },
    svgPlanSetup: {
      plan: $('#plan'),
      init: function () {
        var _this = this;

        this.plan.find('polyline').each(function () {
          var polyline = $(this);
          var center = SVG.adopt(polyline[0]).bbox();
          var textOffset = polyline.data('text-offset');

          var group = SVG(_this.plan[0]).group()

          var text = SVG(_this.plan[0]).text(function (add) {
            if (polyline.data('showtitle') == 1) {
              titlearray = polyline.data('title').split('|');
              console.log(titlearray);
              for (a = 0; a < titlearray.length; a++) {
                if (a == (titlearray.length)) {
                  add.tspan(titlearray[a]).dx(10);
                } else {
                  add.tspan(titlearray[a]).dx(10).newLine();

                }
              }
            }
            if (polyline.data('future') == 1) {
              add.tspan(polyline.data('futuretext')).newLine().dx(20).font({
                'weight': 500
              });
            }
            if (polyline.data('sold') == 1) {
              add.tspan('Sold').newLine().dx(20).fill('#b50011').font({
                'weight': 500
              });
            }
          }).font({
            family: 'klavika-web',
            anchor: 'middle'
          }).move(center.cx + textOffset.x, center.cy + textOffset.y);

          group.add(SVG.adopt(polyline[0]));
          group.add(text);

          if (polyline.hasClass('popup') || polyline.hasClass('image')) {
            group.on('mouseenter', function () {
              group.addClass('hover');
              group.fill({
                color: '#fff'
              });
            });
            group.on('mouseleave', function () {
              group.removeClass('hover');
              group.fill({
                color: '#000'
              });
            });

            //group.addClass('fancybox').attr('href', polyline.data('href')).attr('data-fancybox', 'units');

            group.on('click', function () {
              if (polyline.hasClass('image')) {
                $.fancybox.open({
                  src: polyline.data('image'),
                  type: 'image'
                });
              } else {
                $.fancybox.open({
                  src: polyline.data('href')
                }, {
                  type: 'ajax',
                  toolbar: true,
                  buttons: [
                    'close'
                  ],
                  arrows: true,
                  maxWidth: 960,
                  smallBtn: true,
                  afterLoad: function () {
                    $('.js-tabs a').click(function (event) {
                      event.preventDefault();

                      var tab_id = $(this).data('tab');


                      $('.js-tabs a').removeClass('current');
                      $(this).addClass('current');
                      $('div.tab').removeClass('current');
                      $('#tab' + tab_id).addClass('current');
                    })
                  }
                });
              }
            });
          }
        });

        /*$().fancybox({
            selector : 'g.fancybox',
            loop: true,
            type: 'ajax',
            toolbar : true,
            buttons : [
            'close'
          ],
            arrows : true,
            maxWidth: 960,
            smallBtn: true,
            afterLoad: function(){
                $('.js-tabs a').click(function(event){
                    event.preventDefault();

                var tab_id = $(this).data('tab');


                    $('.js-tabs a').removeClass('current');
                    $(this).addClass('current');
                    $('div.tab').removeClass('current');
                    $('#tab'+tab_id).addClass('current');
                })
            }
        });*/

      }
    },
    nav: {
      button: $('.js-menu-btn'),
      menu: $('.js-menu'),
      menuhaschildren: $('.js-menuhaschildren'),
      menuscroll: $('.js-menuscroll'),
      menuItems: $('.js-navscrolltosection'),
      lastId: 0,
      topMenuHeight: 1,
      scrollItems: null,
      init: function () {
        var _this = this;

        this.button.on('click', function () {
          if (_this.menu.hasClass('active')) {
            _this.menu.removeClass('active');
            $(this).removeClass('active');
          } else {
            _this.menu.show().addClass('active');
            $(this).addClass('active');
            _this.menu.height($(window).innerHeight());
            _this.menuscroll.height(parseInt($(window).innerHeight() - 120));
          }

          $(window).resize(function () {
            _this.menu.height($(window).innerHeight());
            _this.menuscroll.height(parseInt($(window).innerHeight() - 120));
          });
        });

        this.scrollItems = _this.menuItems.map(function () {
          var i = $(this).attr("href");
          var item = $(i.replace('/', ''));
          if (item.length) {
            return item;
          }
        });

        this.menuhaschildren.click(function (event) {
          if ($(this).hasClass('redirectorpage') || $(event.target).is('span.haschildren')) {
            event.preventDefault();

            $(this).toggleClass('current');
          }
        });

        this.menuItems.click(function (e) {
          var href = $(this).attr("href").replace('/', ''),
            offsetTop = href === "#home" ? 0 : $(href).offset().top - _this.topMenuHeight + 1;
          $('html, body').stop().animate({
            scrollTop: offsetTop
          }, 300);
          e.preventDefault();

          _this.menu.removeClass('active');
          _this.button.removeClass('active');
        });

        $(window).on('load', function () {
          _this.detectPos($(this), _this);
        });

        $(window).on('scroll', function () {
          _this.detectPos($(this), _this);
        });

        $('body').click(function (event) {
          if (!$(event.target).is('.js-menu, .js-menu-btn, .js-menu *, .js-menu-btn *') && _this.menu.hasClass('active')) {
            _this.menu.removeClass('active');
            _this.button.removeClass('active');
          }
        });
      },
      detectPos: function (win, _this) {
        // Bind to scroll

        // Get container scroll position
        var fromTop = win.scrollTop() + _this.topMenuHeight;

        // Get id of current scroll item
        var cur = _this.scrollItems.map(function () {
          if ($(this).offset().top < fromTop)
            return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (_this.lastId !== id) {
          _this.lastId = id;

          // Set/remove active class
          _this.menuItems.removeClass("current").filter("[href='/#" + id + "']").addClass("current");
        }

      }
    },
    headershrink: {
      header: $('#header'),
      shrunk: 0,
      init: function () {
        var _this = this;
        //var shrunk = 0;
        this.checkscroll();

        $(window).scroll(function () {
          _this.checkscroll();
        });
      },
      checkscroll: function () {
        var scrolltop = ($(document).scrollTop());

        if (scrolltop > 50 && this.shrunk == 0) {
          this.header.addClass('headershrink');
          this.shrunk = 1;

        } else if (scrolltop <= 50 && this.shrunk == 1) {
          this.header.removeClass('headershrink');
          this.shrunk = 0;
        }
      }
    },
    hero: {
      container: $('.js-hero'),
      init: function () {
        var _this = this;

        _this.container.slick({
          autoplay: true,
          autoplaySpeed: 8000,
          speed: 800,
          fade: true,
          prevArrow: '<button class="slick-arrow slick-prev">',
          nextArrow: '<button class="slick-arrow slick-next">'
        });
      }
    },
    fullpage: {
      sectionfullpage: $('.js-fullpage'),
      init: function () {
        var _this = this;
        var heightcalc = $(window).innerHeight();
        var ratiocalc = 0.5;

        _this.sectionfullpage.height(heightcalc);
        //_this.sectionfullpage.find('img').css('max-width', heightcalc*ratiocalc);

        $(window).resize(function () {
          heightcalc = $(window).innerHeight();
          _this.sectionfullpage.height(heightcalc);
          //_this.sectionfullpage.find('img').css('max-width', heightcalc*ratiocalc);
        });
      }
    },
    smoothScroll: {
      button: $('.js-scroll'),
      init: function () {
        this.buttonEvent();
      },
      buttonEvent: function () {
        this.button.on('click', function () {
          if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 600);
              return false;
            }
          }
        });
      }
    },
    setupMap: {
      init: function () {
        $.getScript("//maps.google.com/maps/api/js?key=AIzaSyCHiYHYISk4XnbKpsVFACJezlCqK9EyfoQ&async=2&callback=MapApiLoaded", function () { });
      }
    }
  }

  SCRIPTS.init();
});

function MapApiLoaded() {
  var map = null;
  var mapcenter = null;
  var mapobj = $('#js-map');

  var mapzoom = mapobj.data('zoom');
  var maplat = mapobj.data('lat');
  var maplng = mapobj.data('lng');
  var maplatcenter = maplat;
  var maplngcenter = maplng;
  if (typeof (mapobj.data('centerlat')) != 'undefined') {
    maplatcenter = mapobj.data('centerlat');
    maplngcenter = mapobj.data('centerlng');
  }
  var markertitle = mapobj.data('title');


  var styleArray = [{
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [{
      "visibility": "on"
    }, {
      "saturation": -100
    }, {
      "lightness": 20
    }]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
      "visibility": "on"
    }, {
      "saturation": -100
    }, {
      "lightness": 40
    }]
  }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
      "visibility": "on"
    }, {
      "saturation": -10
    }, {
      "lightness": 30
    }]
  }, {
    "featureType": "landscape.man_made",
    "elementType": "all",
    "stylers": [{
      "visibility": "simplified"
    }, {
      "saturation": -60
    }, {
      "lightness": 10
    }]
  }, {
    "featureType": "landscape.natural",
    "elementType": "all",
    "stylers": [{
      "visibility": "simplified"
    }, {
      "saturation": -60
    }, {
      "lightness": 60
    }]
  }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }, {
      "saturation": -100
    }, {
      "lightness": 60
    }]
  }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }, {
      "saturation": -100
    }, {
      "lightness": 60
    }]
  }];

  function calculateCenter() {
    mapcenter = map.getCenter();
  }

  map = new google.maps.Map(document.getElementById('js-map'), {
    zoom: mapzoom,
    scrollwheel: false,
    styles: styleArray,
    streetViewControl: false,
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    center: {
      lat: maplatcenter,
      lng: maplngcenter
    }
  });

  google.maps.event.addDomListener(map, 'idle', function () {
    calculateCenter();
  });
  google.maps.event.addDomListener(window, 'resize', function () {
    map.setCenter(mapcenter);
  });

  var infoWindow = new google.maps.InfoWindow({
    content: ''
  });

  var image = '/themes/alphaprop/images/marker.png';
  var pointLatLng = new google.maps.LatLng(maplat, maplng);

  marker = new google.maps.Marker({
    position: pointLatLng,
    title: markertitle,
    content: '<a href="http://maps.apple.com/?daddr=' + maplat + ',' + maplng + '" target="_blank">Get Directions</a>',
    map: map,
    icon: image
  });

  google.maps.event.addListener(marker, 'click', function () {
    infoWindow.setPosition(this.position);
    infoWindow.setContent('<p><strong>' + this.title + '</strong></p><p>' + this.content + '</p>');
    infoWindow.open(map, marker);
  })

  marker.setMap(map);
}
